/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AcademyIndexRouteImport } from './routes/academy.index'
import { Route as AcademyLessonIdRouteImport } from './routes/academy.$lessonId'
import { Route as SandboxesSandboxIdRouteImport } from './routes/sandboxes.$sandboxId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AcademyIndexRoute = AcademyIndexRouteImport.update({
  id: '/academy/',
  path: '/academy/',
  getParentRoute: () => rootRouteImport,
} as any)
const AcademyLessonIdRoute = AcademyLessonIdRouteImport.update({
  id: '/academy/$lessonId',
  path: '/academy/$lessonId',
  getParentRoute: () => rootRouteImport,
} as any)
const SandboxesSandboxIdRoute = SandboxesSandboxIdRouteImport.update({
  id: '/sandboxes/$sandboxId',
  path: '/sandboxes/$sandboxId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/academy/$lessonId': typeof AcademyLessonIdRoute
  '/sandboxes/$sandboxId': typeof SandboxesSandboxIdRoute
  '/academy/': typeof AcademyIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/academy/$lessonId': typeof AcademyLessonIdRoute
  '/sandboxes/$sandboxId': typeof SandboxesSandboxIdRoute
  '/academy': typeof AcademyIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/academy/$lessonId': typeof AcademyLessonIdRoute
  '/sandboxes/$sandboxId': typeof SandboxesSandboxIdRoute
  '/academy/': typeof AcademyIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/academy/$lessonId' | '/sandboxes/$sandboxId' | '/academy/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/academy/$lessonId' | '/sandboxes/$sandboxId' | '/academy'
  id:
    | '__root__'
    | '/'
    | '/academy/$lessonId'
    | '/sandboxes/$sandboxId'
    | '/academy/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AcademyLessonIdRoute: typeof AcademyLessonIdRoute
  SandboxesSandboxIdRoute: typeof SandboxesSandboxIdRoute
  AcademyIndexRoute: typeof AcademyIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/academy/': {
      id: '/academy/'
      path: '/academy'
      fullPath: '/academy/'
      preLoaderRoute: typeof AcademyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/academy/$lessonId': {
      id: '/academy/$lessonId'
      path: '/academy/$lessonId'
      fullPath: '/academy/$lessonId'
      preLoaderRoute: typeof AcademyLessonIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sandboxes/$sandboxId': {
      id: '/sandboxes/$sandboxId'
      path: '/sandboxes/$sandboxId'
      fullPath: '/sandboxes/$sandboxId'
      preLoaderRoute: typeof SandboxesSandboxIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AcademyLessonIdRoute: AcademyLessonIdRoute,
  SandboxesSandboxIdRoute: SandboxesSandboxIdRoute,
  AcademyIndexRoute: AcademyIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
